import styled from 'styled-components';

const ReportIncludedFields = styled.div`
  display: grid;
  grid-template-columns: 30% 1fr;
  grid-row-gap: ${(props): string => props.theme.spaces.lg};
  grid-auto-rows: min-content;

  > span {
    padding: ${(props): string => `${props.theme.spaces.sm} 0`};
  }

  > hr {
    grid-column: 1 / -1;
    height: 0.1rem;
    border: transparent;
    border-top: solid 0.1rem ${(props): string => props.theme.colors.iceGray};
    width: 100%;
    align-self: center;
    margin: 0;

    &:last-of-type {
      display: none;
    }
  }
`;

export { ReportIncludedFields };
